module.exports = __webpack_public_path__ + "static/media/introduce.d0dfff57.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程GLR增程式厢式车/introduce.png
// module id = 707
// module chunks = 0